import {
  FolderRegular,
  ImageRegular,
  HomeRegular,
  DataTrendingRegular,
  StyleGuideRegular,
  VideoRegular,
  KeyboardLayoutOneHandedLeft20Regular,
} from '@fluentui/react-icons';
import { getSearchQuery } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

const isSubPageSelected = (pathname, subPage, rootRoute) => pathname.includes(`${rootRoute}/${subPage}`);

const isHomePageSelected = (pathname, rootRoute) => (pathname === rootRoute) || isSubPageSelected(pathname, 'home', rootRoute);

const gotoPage = (history, rootRoute, path, search) => {
  const currentSearch = getSearchQuery({ search });
  history.push(`${rootRoute}${path}${currentSearch}`);
};

export const gotoLibraryPage = (history, rootRoute, search) => {
  const isLibraryPage = isSubPageSelected(history.location.pathname, 'library', rootRoute);
  if (!isLibraryPage) {
    gotoPage(history, rootRoute, '/library', search);
  }
};

export const isLibraryPageSelected = (pathname, rootRoute) => isSubPageSelected(pathname, 'library', rootRoute);

export const getStaticItems = (history, rootRoute, navigateIntoFolderItem, brandKitEnabled) => {
  const { location } = history;
  const { search, pathname } = location;

  const isBrandKitEnabled = brandKitEnabled;

  return [
    {
      id: 'ad-studio-home-page',
      name: _TL_('Home'),
      route: 'adstudio/home',
      onClick: () => gotoPage(history, rootRoute, '/home', search),
      icon: HomeRegular,
      isSelected: isHomePageSelected(pathname, rootRoute),
    },
    {
      id: 'ad-studio-images-page',
      name: _TL_('Images'),
      route: 'adstudio/images',
      onClick: () => gotoPage(history, rootRoute, '/images', search),
      icon: ImageRegular,
      isSelected: isSubPageSelected(pathname, 'images', rootRoute),
    },
    ...isBrandKitEnabled ? [{
      id: 'ad-studio-display-templates-page',
      name: _TL_('Display templates'),
      route: 'adstudio/displaytemplates',
      onClick: () => gotoPage(history, rootRoute, '/displaytemplates', search),
      icon: KeyboardLayoutOneHandedLeft20Regular,
      isSelected: isSubPageSelected(pathname, 'displaytemplates', rootRoute),
    }] : [],
    {
      id: 'ad-studio-videos-page',
      name: _TL_('Videos'),
      route: 'adstudio/videos',
      onClick: () => gotoPage(history, rootRoute, '/videos', search),
      icon: VideoRegular,
      isSelected: isSubPageSelected(pathname, 'videos', rootRoute),
    },
    {
      id: 'ad-studio-performance-page',
      name: _TL_('Performance'),
      route: 'adstudio/performance',
      onClick: () => gotoPage(history, rootRoute, '/performance', search),
      icon: DataTrendingRegular,
      isSelected: isSubPageSelected(pathname, 'performance', rootRoute),
    },
    ...isBrandKitEnabled ? [{
      id: 'ad-studio-brand-kit-page',
      name: _TL_('Brand kit'),
      route: 'adstudio/brandkit',
      onClick: () => gotoPage(history, rootRoute, '/brandkit', search),
      icon: StyleGuideRegular,
      isSelected: isSubPageSelected(pathname, 'brandkit', rootRoute),
    }] : [],
    {
      id: 'ad-studio-library-page',
      name: _TL_('Library'),
      route: 'adstudio/library',
      onClick: () => {
        gotoPage(history, rootRoute, '/library', search);
        navigateIntoFolderItem({ folder: {} });
      },
      icon: FolderRegular,
      isSelected: isSubPageSelected(pathname, 'library', rootRoute),
      showDivider: true,
    },
  ];
};

export const getGroupedItems = (history, rootRoute, navigateIntoFolderItem, brandKitEnabled) => {
  const { location } = history;
  const { search, pathname } = location;

  const isBrandKitEnabled = brandKitEnabled;

  return [
    [
      {
        id: 'ad-studio-home-page',
        name: _TL_('Home'),
        route: 'adstudio/home',
        onClick: () => gotoPage(history, rootRoute, '/home', search),
        icon: HomeRegular,
        isSelected: isHomePageSelected(pathname, rootRoute),
      },
      {
        id: 'ad-studio-images-page',
        name: _TL_('Images'),
        route: 'adstudio/images',
        onClick: () => gotoPage(history, rootRoute, '/images', search),
        icon: ImageRegular,
        isSelected: isSubPageSelected(pathname, 'images', rootRoute),
      },
      ...isBrandKitEnabled ? [{
        id: 'ad-studio-display-templates-page',
        name: _TL_('Display templates'),
        route: 'adstudio/displaytemplates',
        onClick: () => gotoPage(history, rootRoute, '/displaytemplates', search),
        icon: KeyboardLayoutOneHandedLeft20Regular,
        isSelected: isSubPageSelected(pathname, 'displaytemplates', rootRoute),
      }] : [],
      {
        id: 'ad-studio-videos-page',
        name: _TL_('Videos'),
        route: 'adstudio/videos',
        onClick: () => gotoPage(history, rootRoute, '/videos', search),
        icon: VideoRegular,
        isSelected: isSubPageSelected(pathname, 'videos', rootRoute),
      },
      {
        id: 'ad-studio-performance-page',
        name: _TL_('Performance'),
        route: 'adstudio/performance',
        onClick: () => gotoPage(history, rootRoute, '/performance', search),
        icon: DataTrendingRegular,
        isSelected: isSubPageSelected(pathname, 'performance', rootRoute),
      },
      ...isBrandKitEnabled ? [{
        id: 'ad-studio-brand-kit-page',
        name: _TL_('Brand kit'),
        route: 'adstudio/brandkit',
        onClick: () => gotoPage(history, rootRoute, '/brandkit', search),
        icon: StyleGuideRegular,
        isSelected: isSubPageSelected(pathname, 'brandkit', rootRoute),
      }] : [],
    ],
    [
      {
        id: 'ad-studio-library-page',
        name: _TL_('Library'),
        route: 'adstudio/library',
        onClick: () => {
          gotoPage(history, rootRoute, '/library', search);
          navigateIntoFolderItem({ folder: {} });
        },
        icon: FolderRegular,
        isSelected: isSubPageSelected(pathname, 'library', rootRoute),
        showDivider: true,
      },
      {
        id: 'folder-path-tree',
      },
    ],
  ];
};

export const LOADING_CELL = {};

export const MaxFolderLevel = 6;
